import { useRequiredContext } from "@redotech/react-util/context";
import BoxIcon from "@redotech/redo-icons/box-01.svg";
import BoxFilledIcon from "@redotech/redo-icons/box_filled.svg";
import ListIcon from "@redotech/redo-icons/list.svg";
import ListFilledIcon from "@redotech/redo-icons/list_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo, useContext } from "react";
import { useMatch } from "react-router-dom";
import {
  OrderManagementSuiteStatusesContext,
  WAREHOUSE_ICON,
  WAREHOUSE_ICON_FILLED,
} from "../../../../redo-suite/order-management-cloud";

export const WarehouseItem = memo(function WarehouseItem() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const { wmsEnabled } = useContext(OrderManagementSuiteStatusesContext);

  const wmsBaseUrl = `${routes.orderManagementBaseUrl}/wms`;
  const warehouseMatch = useMatch(`${routes.warehouseBaseUrl}/*`);
  const wmsMatch = useMatch(`${wmsBaseUrl}/*`);
  const anyChildSelected = !!warehouseMatch || !!wmsMatch;

  if (!wmsEnabled) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "button" }}
      anyChildSelected={anyChildSelected}
      FilledIcon={WAREHOUSE_ICON_FILLED}
      friendlyName="Warehouse management"
      id="warehouse-management"
      UnfilledIcon={WAREHOUSE_ICON}
    >
      {/* Alphabetized items */}
      <RedoSecondaryNavItem
        action={{ type: "link", href: `${wmsBaseUrl}/storage-locations` }}
        FilledIcon={BoxFilledIcon}
        friendlyName="Bins"
        id="bins"
        UnfilledIcon={BoxIcon}
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: `${wmsBaseUrl}/inventory-level-ledger` }}
        FilledIcon={ListFilledIcon}
        friendlyName="Inventory ledger"
        id="inventory-ledger"
        UnfilledIcon={ListIcon}
      />
      <RedoSecondaryNavItem
        action={{ type: "link", href: routes.warehouseHref }}
        FilledIcon={WAREHOUSE_ICON_FILLED}
        friendlyName="Overview"
        id="warehouse-overview"
        UnfilledIcon={WAREHOUSE_ICON}
      />
    </RedoSecondaryNavItem>
  );
});
